import { useSelector } from 'react-redux';

import { languages } from 'src/config/i18n.config.mjs';
import { getFeatureFlags } from 'src/modules/user/selectors/featureFlags';
import { getUserInformation } from 'src/modules/user/selectors/userSelectors';

// Returns whether we should be using the localized version of the app for this user.
export const useLocalizedVersion = () => {
    const { translationUi } = useSelector(getFeatureFlags);
    const { languagePreferences } = useSelector(getUserInformation);

    return [
        translationUi &&
            languagePreferences.length > 0 &&
            languages[languagePreferences[0]] !== 'en-US',
    ];
};
